module.exports = __webpack_public_path__ + "static/_myWellnessLogo-4d7ea7d3720f322b546d16cfa661b5ed.png";